import request from '@/utils/request'

// 抵扣券发放列表
export function renewalBonus_index(data) {
  return request({
    url: '/merchant/renewalBonus/index',
    method: 'get',
    params: data
  }).then((res) => {
    // MyTable 使用 count，接口返回 total
    if (res && res.total != null && res.count == null) {
      res.count = res.total
    }
    return res
  })
}

// 抵扣券发放记录删除（软删除并扣除余额）
export function renewalBonus_delete(data) {
  return request({
    url: '/merchant/renewalBonus/delete',
    method: 'post',
    data: data
  })
}
